// already-logged-in.guard.ts
import { Injectable, Inject, PLATFORM_ID } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';
import { isPlatformBrowser } from '@angular/common';
import{AuthService} from '../../services/auth/auth.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AlreadyLoggedInGuard implements CanActivate {
  constructor(
    private authService: AuthService, 
    private router: Router,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {}

  canActivate(): boolean | UrlTree {
    // On server-side, allow navigation (will be checked again on client)
    if (!isPlatformBrowser(this.platformId)) {
      return true;
    }

    // On browser, check token directly from sessionStorage to avoid timing issues
    const token = sessionStorage.getItem('token');
    if (token) {
      // Redirect to dashboard if already logged in
     // console.log('User already logged in, redirecting to dashboard...');
      return this.router.parseUrl('/dashboard');
    }
    return true;
  }
}
